import { render, staticRenderFns } from "./UpdateCostModal.vue?vue&type=template&id=ed56e43a&"
import script from "./UpdateCostModal.vue?vue&type=script&lang=js&"
export * from "./UpdateCostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports